import { CalendarClock, Video } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Field, StepHeader } from "@/components/apply/Field";

const minLocal = () => {
  const d = new Date(Date.now() + 24 * 3600 * 1000);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

export const StepInterview = ({ form, setForm }) => {
  const setSlot = (i) => (e) =>
    setForm((f) => {
      const s = [...f.interview_slots];
      s[i] = e.target.value;
      return { ...f, interview_slots: s };
    });
  return (
    <div data-testid="step-interview">
      <StepHeader title="Pick your interview times" text="Choose 3 preferred dates and times for a short Zoom video interview." />
      <div className="mb-6 inline-flex items-center gap-2 rounded-full bg-purple-500/10 border border-purple-500/30 px-4 py-2 text-sm font-semibold" data-testid="apply-interview-timezone">
        <CalendarClock className="h-4 w-4 text-purple-500" /> Times shown in {form.contact.timezone}
      </div>
      <div className="grid gap-5 sm:grid-cols-3">
        {[0, 1, 2].map((i) => (
          <Field key={i} label={`Option ${i + 1}`}>
            <Input type="datetime-local" min={minLocal()} className="h-12 rounded-xl" value={form.interview_slots[i]} onChange={setSlot(i)} data-testid={`apply-interview-slot-${i + 1}`} />
          </Field>
        ))}
      </div>
      <div className="mt-6 flex items-start gap-3 rounded-2xl border border-border p-4 text-sm text-muted-foreground">
        <Video className="h-5 w-5 text-primary shrink-0" />
        <p>We'll confirm one of these times by email with your Zoom link. Please have your ID with you on the call.</p>
      </div>
    </div>
  );
};
